<template>
  <div class="form-group">
    <label v-if="label" class="control-label w-100">
      <span>{{ label }}</span>
    </label>

    <el-select
      v-model="selected"
      v-validate="modelValidations.campaign"
      autocomplete="off"
      filterable
      name="campaign"
      placeholder="Seleccione Campaña (*)"
      @change="onSelected"
    >
      <el-option
        v-for="option in campaignsOptions"
        :key="option.value"
        :label="option.label.substring(0, 20)"
        :value="option.value"
      >
      </el-option>
    </el-select>

    <small v-show="campaign.invalid && allFilter === null" class="text-danger">
      {{ getError('campaign') }}
    </small>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Select, Option } from 'element-ui';
import { mapState } from 'vuex';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    value: {
      type: [Array, String, Number, Object],
      default: null,
    },

    required: {
      type: Boolean,
      default: true,
    },

    label: {
      type: String,
      default: 'Seleccione Campaña',
    },

    allFilter: {
      type: String,
      default: null,
    },

    exclude: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      selected: null,
      modelValidations: {
        campaign: {
          required: this.required,
          is_not: this.exclude,
        },
      },
    };
  },

  computed: {
    ...mapState('models/campaign', ['campaigns']),

    ...mapFields(['campaign']),

    campaignsOptions() {
      const campaigns = [...this.campaigns];

      if (this.allFilter) {
        campaigns.unshift({ id: null, name: this.allFilter });
      }

      if (this.exclude) {
        return this.$selectOptions(campaigns.filter((campaign) => this.exclude !== campaign.id));
      }

      return this.$selectOptions(campaigns);
    },
  },

  async mounted() {
    this.selected = this.value;
  },

  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll();
    },

    onSelected() {
      this.$emit('input', this.selected);
    },

    getSelected() {
      return this.campaigns.find((campaign) => campaign.id === this.selected);
    },
  },
};
</script>
